import {
    ChevronDownIcon,
    DocumentIcon2,
    DocumentWithPencilIcon,
    PayIcon,
    PermissionIcon,
    PlanetIcon,
    SettingsIcon,
} from '@/shared/assets'
import clsx from 'clsx'
import { useState } from 'react'
import { NavbarItem } from '../NavbarItem/NavbarItem'
import './navbarSettings.scss'
import {
    workspacePath,
    useActiveWorkspace,
} from '@/true-fsd/data/advertiser-account'

export const NavbarSettings = ({ isOpen }: { isOpen: boolean }) => {
    // const { user } = useStore()
    const {
        activeWorkspace,
        permission,
        ordData: { ordAdditionalData },
    } = useActiveWorkspace()

    const [isSettingsOpen, setIsSettingsOpen] = useState(false)
    const toggleSettingsMenu = () => setIsSettingsOpen((v) => !v)

    // const shouldShowOrd = useGetFeatureFlagByKey('ord', user?.user_id)
    // const shouldShowPA = useGetFeatureFlagByKey('RA', user?.user_id)

    const isAgencyOrdType = ordAdditionalData?.currentLinkType === 'agency'

    return (
        <div className="navbar-settings">
            <div
                className={clsx('navbar-settings__button', {
                    open: isOpen,
                })}
                onClick={toggleSettingsMenu}
            >
                <img
                    src={SettingsIcon}
                    alt="Settings"
                    className="navbar-settings__button__icon"
                />
                <p
                    className={clsx('navbar-settings__button__text', {
                        closed: !isOpen,
                    })}
                >
                    Настройки
                </p>
                <img
                    src={ChevronDownIcon}
                    className={clsx('navbar-settings__button__chevron', {
                        open: isSettingsOpen,
                        closed: !isOpen,
                    })}
                />
            </div>
            <div
                className={clsx('navbar-settings__items', {
                    open: isOpen && isSettingsOpen,
                })}
            >
                <NavbarItem
                    to={workspacePath(activeWorkspace, 'settings/marking')}
                    icon={DocumentIcon2}
                    text="Маркировка"
                    isOpen={isOpen}
                    isChild={true}
                    disabled={!permission.admin}
                />
                <NavbarItem
                    to={workspacePath(activeWorkspace, 'settings/documents')}
                    icon={DocumentWithPencilIcon}
                    text="Документы"
                    isOpen={isOpen}
                    isChild={true}
                    disabled={!permission.admin || !isAgencyOrdType}
                />
                {activeWorkspace.workspace_type === 'site' && (
                    <NavbarItem
                        to={workspacePath(
                            activeWorkspace,
                            'settings/site-integration'
                        )}
                        icon={PlanetIcon}
                        text="Интеграция с&nbsp;сайтом"
                        isOpen={isOpen}
                        isChild={true}
                        classNameText="navbar-settings__items__text leading-[15.6px]"
                    />
                )}
                <NavbarItem
                    to={workspacePath(activeWorkspace, 'settings/permissions')}
                    icon={PermissionIcon}
                    text="Доступы"
                    isOpen={isOpen}
                    isChild={true}
                    disabled={!permission.admin}
                />
                <NavbarItem
                    to={workspacePath(activeWorkspace, 'settings/subscription')}
                    icon={PayIcon}
                    text="Тариф и оплата"
                    isOpen={isOpen}
                    isChild={true}
                    classNameText="navbar-settings__items__text"
                />
                {/* <NavbarItem */}
                {/*     to="/settings/about-advertizer" */}
                {/*     icon={DataIcon} */}
                {/*     text="О рекламодателе" */}
                {/*     isOpen={isOpen} */}
                {/*     isChild={true} */}
                {/* /> */}
            </div>
        </div>
    )
}
